import SharedProcessingTimeSection, { type ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission — no drive to Atlanta needed",
      "Ideal for Maxwell AFB personnel with PCS or TDY orders",
      "Perfect for Alabama state officials on trade missions",
      "Great for ASU students with study abroad programs",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service at Montgomery post offices",
      "Good for planned international trips from MGM",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "No document review — errors cause rejection",
      "In-person clerk appointment required at Montgomery or Prattville USPS",
      "Workload shifts with government shutdowns and budget fights",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Cannot upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Closest regional agency: Atlanta — ~160 mi, 2.5 hrs drive on I-85",
      "NPIC appointment required before traveling to Atlanta",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis documentation required",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function MontgomeryProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Montgomery"
      introText="Montgomery travelers — Maxwell AFB airmen with PCS orders to Germany and Japan, Alabama state officials heading to trade missions in South Korea and Europe, ASU students studying abroad in Ghana and the UK, and River Region families with Caribbean cruises departing from Mobile — have several options for getting a passport fast. Here is how they compare, and why most Central Alabama residents choose a U.S. Department of State registered passport courier for predictable, professional processing without the drive to Atlanta."
      options={options}
      emergencyDescription="Montgomery does not have its own regional passport agency. The closest is Atlanta — about 160 miles northeast on I-85, typically 2.5 hours but often longer with Atlanta metro traffic. For a Maxwell AFB officer with deployment orders on Monday who finds out on Thursday, or an Alabama state official invited to a trade mission in Seoul next week, that round trip is exhausting."
      disclaimerText="*Processing speed depends on eligibility and documentation. Montgomery does not have a regional passport agency — the closest is Atlanta. Not all applicants qualify for Regional Agency Processing."
    />
  );
}